// AdminLoginPage.js
import React from 'react';
import { Form, Input, Button, Typography, Row, Col, Card, message } from 'antd';
import Layout from '../components/layout';
import { adminLogin } from '../services/authService';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const AdminLoginPage = () => {
  const navigate = useNavigate();

  const handleAdminLogin = async (values) => {
    try {
      const { adminUsername, adminPassword } = values;

      // Call admin login API
      const data = await adminLogin(adminUsername, adminPassword);

      // Store the token in local storage
      localStorage.setItem('adminToken', data.token);
      localStorage.setItem('role', data.role);



      message.success('Admin login successful!');
      navigate('/admin/product'); // Redirect to admin dashboard or another page after login
    } catch (error) {
      message.error(error.message || 'Admin login failed. Please try again.');
    }
  };

  return (
    <Layout>
      <Row justify="center" align="middle" style={{ minHeight: '100vh', padding: '24px' }}>
        <Col xs={24} sm={16} md={12} lg={8}>
          <Card 
            style={{ 
              padding: '24px', 
              borderRadius: '8px', 
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' 
            }}
            bordered
          >
            <Title level={2} style={{ textAlign: 'center', marginBottom: '24px' }}>Admin Login</Title>
            <Form
              name="adminLogin"
              layout="vertical"
              onFinish={handleAdminLogin}
            >
              <Form.Item
                name="adminUsername"
                label="Admin Email"
                rules={[{ required: true, message: 'Please input your admin username!' }]}
              >
                <Input placeholder="Enter admin email" />
              </Form.Item>

              <Form.Item
                name="adminPassword"
                label="Admin Password"
                rules={[{ required: true, message: 'Please input your admin password!' }]}
              >
                <Input.Password placeholder="Enter admin password" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Admin Login
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default AdminLoginPage;
